import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/petType',
        name: '宠物类型',
        meta: {
            title: "宠物类型",
        },
        redirect: '/petType/dogType',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/petType/dogType',
                name: "狗狗列表",
                meta: {
                    title: "狗狗列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/petType/dogType.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petType/catType',
                name: "猫猫列表",
                meta: {
                    title: "猫猫列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/petType/catType.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petType/otherType',
                name: "异宠列表",
                meta: {
                    title: "异宠列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/petType/otherType.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]